"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageQuery = void 0;
const react_1 = __importDefault(require("react"));
const router_1 = require("@reach/router");
const styled_components_1 = __importDefault(require("styled-components"));
const _layouts_1 = require("@layouts");
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const _store_1 = __importDefault(require("@store"));
var scrollToSection = function scrollToSection(destination) {
    var element = document.getElementById(destination.substr(1));
    window.scrollTo({
        left: 0,
        top: ((element === null || element === void 0 ? void 0 : element.offsetTop) || 0) + 50,
        behavior: 'smooth'
    });
}; // Component
var AboutPage = function AboutPage(_ref) {
    var _subtitle$childMarkdo, _firstBlockImage$file, _firstBlock$childMark, _secondBlockImage$fil, _secondBlock$childMar, _secondSectionSubtitl, _thirdBlockImage$file, _thirdBlock$childMark, _fourthBlockImage$fil, _fourthBlock$childMar, _fifthBlockImage$file, _fifthBlock$childMark, _fourthSectionSubtitl, _sixthBlockImage$file, _sixthBlock$childMark, _firstFounderPhoto$fi, _firstFounderBio$chil, _secondFounderPhoto$f, _secondFounderBio$chi;
    var contentfulAboutPage = _ref.data.contentfulAboutPage;
    if (!contentfulAboutPage)
        return null;
    var navigate = router_1.useNavigate();
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }), user = _useGlobal[0];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal3[1];
    var join = function join() {
        if (user) {
            navigate('/experiences');
        }
        else {
            setVisibleDropdown('account');
            setPanel('login');
        }
    };
    var title = contentfulAboutPage.title, subtitle = contentfulAboutPage.subtitle, secondSectionTitle = contentfulAboutPage.secondSectionTitle, secondSectionSubtitle = contentfulAboutPage.secondSectionSubtitle, fourthSectionTitle = contentfulAboutPage.fourthSectionTitle, fourthSectionSubtitle = contentfulAboutPage.fourthSectionSubtitle, firstBlockTitle = contentfulAboutPage.firstBlockTitle, firstBlock = contentfulAboutPage.firstBlock, firstBlockImage = contentfulAboutPage.firstBlockImage, secondBlockTitle = contentfulAboutPage.secondBlockTitle, secondBlock = contentfulAboutPage.secondBlock, secondBlockImage = contentfulAboutPage.secondBlockImage, thirdBlockTitle = contentfulAboutPage.thirdBlockTitle, thirdBlock = contentfulAboutPage.thirdBlock, thirdBlockImage = contentfulAboutPage.thirdBlockImage, fourthBlockTitle = contentfulAboutPage.fourthBlockTitle, fourthBlock = contentfulAboutPage.fourthBlock, fourthBlockImage = contentfulAboutPage.fourthBlockImage, fifthBlockTitle = contentfulAboutPage.fifthBlockTitle, fifthBlock = contentfulAboutPage.fifthBlock, fifthBlockImage = contentfulAboutPage.fifthBlockImage, sixthBlockTitle = contentfulAboutPage.sixthBlockTitle, sixthBlock = contentfulAboutPage.sixthBlock, sixthBlockImage = contentfulAboutPage.sixthBlockImage, thirdSectionTitle = contentfulAboutPage.thirdSectionTitle, firstFounderName = contentfulAboutPage.firstFounderName, firstFounderTitle = contentfulAboutPage.firstFounderTitle, firstFounderBio = contentfulAboutPage.firstFounderBio, firstFounderPhoto = contentfulAboutPage.firstFounderPhoto, secondFounderName = contentfulAboutPage.secondFounderName, secondFounderTitle = contentfulAboutPage.secondFounderTitle, secondFounderBio = contentfulAboutPage.secondFounderBio, secondFounderPhoto = contentfulAboutPage.secondFounderPhoto;
    var _React$useState = react_1.default.useState('#top'), currentSection = _React$useState[0], setCurrentSection = _React$useState[1];
    var waypointTop = _utils_1.useWaypoint({
        waypointSelector: '#top',
        offset: 0
    });
    var waypointMembership = _utils_1.useWaypoint({
        waypointSelector: '#membership',
        offset: -125
    });
    var waypointStudio = _utils_1.useWaypoint({
        waypointSelector: '#studio',
        offset: -125
    });
    var waypointFounders = _utils_1.useWaypoint({
        waypointSelector: '#founders',
        offset: -125
    });
    react_1.default.useEffect(function () {
        // important note: must be listed bottom to top
        if (waypointFounders && currentSection !== '#founders') {
            setCurrentSection('#founders');
        }
        else if (waypointStudio && currentSection !== '#studio') {
            setCurrentSection('#studio');
        }
        else if (waypointMembership && currentSection !== '#membership') {
            setCurrentSection('#membership');
        }
        else if (currentSection !== '#top') {
            setCurrentSection('#top');
        }
    }, [waypointTop, waypointMembership, waypointFounders, waypointStudio]);
    var quickLinks = [{
            label: 'Who We Are',
            onClick: function onClick() {
                return scrollToSection('#top');
            },
            active: currentSection === '#top'
        }, {
            label: 'Membership',
            onClick: function onClick() {
                return scrollToSection('#membership');
            },
            active: currentSection === '#membership'
        }, {
            label: 'PRIOR Studio',
            onClick: function onClick() {
                return scrollToSection('#studio');
            },
            active: currentSection === '#studio'
        }, {
            label: 'Meet the Founders',
            onClick: function onClick() {
                return scrollToSection('#founders');
            },
            active: currentSection === '#founders'
        }];
    var quickLinksBar = /*#__PURE__*/ react_1.default.createElement(molecules_1.QuickLinksBar, {
        links: quickLinks
    });
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.Layout, {
        subHeaderContent: quickLinksBar
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SeoTags, {
        title: "PRIOR - What We Do & Philosophy",
        urlPath: "/about"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.PageHeader, {
        title: title,
        subhead: subtitle === null || subtitle === void 0 ? void 0 : (_subtitle$childMarkdo = subtitle.childMarkdownRemark) === null || _subtitle$childMarkdo === void 0 ? void 0 : _subtitle$childMarkdo.html
    }), /*#__PURE__*/ react_1.default.createElement(Section, null, /*#__PURE__*/ react_1.default.createElement(molecules_1.AlternatingImageLayout, {
        onClick: function onClick() {
            return join();
        },
        imageUrl: firstBlockImage === null || firstBlockImage === void 0 ? void 0 : (_firstBlockImage$file = firstBlockImage.file) === null || _firstBlockImage$file === void 0 ? void 0 : _firstBlockImage$file.url,
        orientation: "right",
        title: firstBlockTitle,
        caption: firstBlock === null || firstBlock === void 0 ? void 0 : (_firstBlock$childMark = firstBlock.childMarkdownRemark) === null || _firstBlock$childMark === void 0 ? void 0 : _firstBlock$childMark.html,
        buttonLabel: "Start Your Journey"
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.AlternatingImageLayout, {
        onClick: function onClick() {
            return join();
        },
        imageUrl: secondBlockImage === null || secondBlockImage === void 0 ? void 0 : (_secondBlockImage$fil = secondBlockImage.file) === null || _secondBlockImage$fil === void 0 ? void 0 : _secondBlockImage$fil.url,
        orientation: "left",
        title: secondBlockTitle,
        caption: secondBlock === null || secondBlock === void 0 ? void 0 : (_secondBlock$childMar = secondBlock.childMarkdownRemark) === null || _secondBlock$childMar === void 0 ? void 0 : _secondBlock$childMar.html,
        buttonLabel: "Start Your Journey"
    })), /*#__PURE__*/ react_1.default.createElement(molecules_1.RegisterInLayout, null), /*#__PURE__*/ react_1.default.createElement(Section, {
        id: "membership"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SectionHeader, {
        title: secondSectionTitle,
        subhead: secondSectionSubtitle === null || secondSectionSubtitle === void 0 ? void 0 : (_secondSectionSubtitl = secondSectionSubtitle.childMarkdownRemark) === null || _secondSectionSubtitl === void 0 ? void 0 : _secondSectionSubtitl.html
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.AlternatingImageLayout, {
        onClick: function onClick() {
            return join();
        },
        imageUrl: thirdBlockImage === null || thirdBlockImage === void 0 ? void 0 : (_thirdBlockImage$file = thirdBlockImage.file) === null || _thirdBlockImage$file === void 0 ? void 0 : _thirdBlockImage$file.url,
        orientation: "right",
        title: thirdBlockTitle,
        caption: thirdBlock === null || thirdBlock === void 0 ? void 0 : (_thirdBlock$childMark = thirdBlock.childMarkdownRemark) === null || _thirdBlock$childMark === void 0 ? void 0 : _thirdBlock$childMark.html,
        buttonLabel: "Start Your Journey"
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.AlternatingImageLayout, {
        onClick: function onClick() {
            return join();
        },
        imageUrl: fourthBlockImage === null || fourthBlockImage === void 0 ? void 0 : (_fourthBlockImage$fil = fourthBlockImage.file) === null || _fourthBlockImage$fil === void 0 ? void 0 : _fourthBlockImage$fil.url,
        orientation: "left",
        title: fourthBlockTitle,
        caption: fourthBlock === null || fourthBlock === void 0 ? void 0 : (_fourthBlock$childMar = fourthBlock.childMarkdownRemark) === null || _fourthBlock$childMar === void 0 ? void 0 : _fourthBlock$childMar.html,
        buttonLabel: "Start Your Journey"
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.AlternatingImageLayout, {
        onClick: function onClick() {
            return join();
        },
        imageUrl: fifthBlockImage === null || fifthBlockImage === void 0 ? void 0 : (_fifthBlockImage$file = fifthBlockImage.file) === null || _fifthBlockImage$file === void 0 ? void 0 : _fifthBlockImage$file.url,
        orientation: "right",
        title: fifthBlockTitle,
        caption: fifthBlock === null || fifthBlock === void 0 ? void 0 : (_fifthBlock$childMark = fifthBlock.childMarkdownRemark) === null || _fifthBlock$childMark === void 0 ? void 0 : _fifthBlock$childMark.html,
        buttonLabel: "Start Your Journey"
    })), /*#__PURE__*/ react_1.default.createElement(Section, {
        id: "studio"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SectionHeader, {
        title: fourthSectionTitle,
        subhead: fourthSectionSubtitle === null || fourthSectionSubtitle === void 0 ? void 0 : (_fourthSectionSubtitl = fourthSectionSubtitle.childMarkdownRemark) === null || _fourthSectionSubtitl === void 0 ? void 0 : _fourthSectionSubtitl.html
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.AlternatingImageLayout, {
        url: "/contact",
        imageUrl: sixthBlockImage === null || sixthBlockImage === void 0 ? void 0 : (_sixthBlockImage$file = sixthBlockImage.file) === null || _sixthBlockImage$file === void 0 ? void 0 : _sixthBlockImage$file.url,
        orientation: "left",
        title: sixthBlockTitle,
        caption: sixthBlock === null || sixthBlock === void 0 ? void 0 : (_sixthBlock$childMark = sixthBlock.childMarkdownRemark) === null || _sixthBlock$childMark === void 0 ? void 0 : _sixthBlock$childMark.html,
        buttonLabel: "Get in touch"
    })), /*#__PURE__*/ react_1.default.createElement(Section, {
        id: "founders"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SectionHeader, {
        title: thirdSectionTitle,
        id: "founders",
        small: true
    }), /*#__PURE__*/ react_1.default.createElement(Founders, null, /*#__PURE__*/ react_1.default.createElement(FoundersStyledMargin, null, /*#__PURE__*/ react_1.default.createElement(FounderCell, null, /*#__PURE__*/ react_1.default.createElement(FounderPortrait, {
        src: firstFounderPhoto === null || firstFounderPhoto === void 0 ? void 0 : (_firstFounderPhoto$fi = firstFounderPhoto.file) === null || _firstFounderPhoto$fi === void 0 ? void 0 : _firstFounderPhoto$fi.url
    }), /*#__PURE__*/ react_1.default.createElement(FounderCopy, null, /*#__PURE__*/ react_1.default.createElement(FounderName, null, firstFounderName), /*#__PURE__*/ react_1.default.createElement(FounderRole, null, firstFounderTitle), /*#__PURE__*/ react_1.default.createElement(FounderBio, {
        dangerouslySetInnerHTML: {
            __html: firstFounderBio === null || firstFounderBio === void 0 ? void 0 : (_firstFounderBio$chil = firstFounderBio.childMarkdownRemark) === null || _firstFounderBio$chil === void 0 ? void 0 : _firstFounderBio$chil.html
        }
    }), /*#__PURE__*/ react_1.default.createElement(FounderRule, null))), /*#__PURE__*/ react_1.default.createElement(FounderCell, null, /*#__PURE__*/ react_1.default.createElement(FounderPortrait, {
        src: secondFounderPhoto === null || secondFounderPhoto === void 0 ? void 0 : (_secondFounderPhoto$f = secondFounderPhoto.file) === null || _secondFounderPhoto$f === void 0 ? void 0 : _secondFounderPhoto$f.url
    }), /*#__PURE__*/ react_1.default.createElement(FounderCopy, null, /*#__PURE__*/ react_1.default.createElement(FounderName, null, secondFounderName), /*#__PURE__*/ react_1.default.createElement(FounderRole, null, secondFounderTitle), /*#__PURE__*/ react_1.default.createElement(FounderBio, {
        dangerouslySetInnerHTML: {
            __html: secondFounderBio === null || secondFounderBio === void 0 ? void 0 : (_secondFounderBio$chi = secondFounderBio.childMarkdownRemark) === null || _secondFounderBio$chi === void 0 ? void 0 : _secondFounderBio$chi.html
        }
    }), /*#__PURE__*/ react_1.default.createElement(FounderRule, null)))))), /*#__PURE__*/ react_1.default.createElement(organisms_1.HomepageHero, null));
}; // Styling
var Section = styled_components_1.default.section.withConfig({
    displayName: "about__Section",
    componentId: "sc-1unnn0m-0"
})([""]);
var Founders = styled_components_1.default.div.withConfig({
    displayName: "about__Founders",
    componentId: "sc-1unnn0m-1"
})(["position:relative;padding:16px 0;", "{padding:20px 0;}", "{padding:24px 0;}", "{padding:32px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var FoundersStyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "about__FoundersStyledMargin",
    componentId: "sc-1unnn0m-2"
})(["position:relative;display:flex;flex-direction:column;align-items:center;", "{display:flex;flex-direction:row;justify-content:space-between;align-items:flex-start;}"], _utils_1.mediaQuery('tablet'));
var FounderCell = styled_components_1.default.div.withConfig({
    displayName: "about__FounderCell",
    componentId: "sc-1unnn0m-3"
})(["flex:0 1 calc(50% - 64px);position:relative;display:flex;flex-direction:column;align-items:center;"]);
var FounderPortrait = styled_components_1.default.img.withConfig({
    displayName: "about__FounderPortrait",
    componentId: "sc-1unnn0m-4"
})(["display:block;width:100%;max-width:420px;height:auto;object-fit:cover;", "{max-width:90%;}"], _utils_1.mediaQuery('tablet'));
var FounderCopy = styled_components_1.default.div.withConfig({
    displayName: "about__FounderCopy",
    componentId: "sc-1unnn0m-5"
})(["position:relative;display:flex;flex-direction:column;align-items:center;max-width:428px;padding:32px 24px;", "{max-width:90%;padding:40px 0;}", "{padding:48px 32px;}", "{padding:64px 40px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var FounderName = styled_components_1.default.h3.withConfig({
    displayName: "about__FounderName",
    componentId: "sc-1unnn0m-6"
})(["max-width:480px;", " text-align:center;color:", ";"], _theme_1.type.h2, _theme_1.palette.black);
var FounderRole = styled_components_1.default.h4.withConfig({
    displayName: "about__FounderRole",
    componentId: "sc-1unnn0m-7"
})(["padding-top:1px;", " text-align:center;color:", ";", "{padding-top:5px;}"], _theme_1.type.h5, _theme_1.palette.black, _utils_1.mediaQuery('desktop'));
var FounderBio = styled_components_1.default.div.withConfig({
    displayName: "about__FounderBio",
    componentId: "sc-1unnn0m-8"
})(["max-width:420px;padding-top:15px;", " text-align:center;", "{max-width:440px;padding-top:16px;}", "{max-width:600px;padding-top:22px;}", "{max-width:680px;padding-top:28px;}"], _theme_1.type.p, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var FounderRule = styled_components_1.default.div.withConfig({
    displayName: "about__FounderRule",
    componentId: "sc-1unnn0m-9"
})(["border-bottom:1px solid ", ";width:32%;padding-top:19px;", "{padding-top:23px;}", "{padding-top:29px;}", "{padding-top:37px;}"], _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Data
exports.pageQuery = "2069400744";
exports.default = AboutPage;
